import React, { useState } from 'react'
import {
    Card,
    CardBody,
    CardHeader,
    Row,
    CardImg,
    NavLink,
    Popover,
    PopoverHeader,
    PopoverBody,
    Button,
} from 'reactstrap'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import './roomItem.css'
import { deleteRoom, updateRoomTitle } from '../../../../redux/tools/actions'
import InlineEditor from '../../../../components/Tools/inlineEditor'
import classnames from 'classnames'
import editImage from '../../../../assets/img/navbarIcons/edit.svg'
import trashImage from '../../../../assets/img/navbarIcons/trash.svg'

const RoomItem = (props) => {
    const deleteHandler = () => {
        props.deleteRoom(props.room.id)
        toggleDeletePopover()
    }

    const toggleDeletePopover = () =>
        setIsDeletePopoverVisible(!isDeletePopoverVisible)

    const [isDeletePopoverVisible, setIsDeletePopoverVisible] = useState(false)
    const [isHover, setIsHover] = useState(false)

    const handleEditRoom = (newTitle) => {
        props.updateRoomTitle(props.room.id, newTitle)
    }

    const roomCardClassName = classnames('room-card', { 'is-hover': isHover })

    return (
        <Card
            className={roomCardClassName}
            onClick={() => props.chooseRoomHandler(props.room)}
            onFocus={() => setIsHover(true)}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            tabIndex={props.tabIndex}
        >
            <CardImg
                width="100%"
                className="main-img"
                src={
                    props.room.editedThumbnailUrl ??
                    props.room.originalThumbnailUrl
                }
            />
            <InlineEditor title={props.room.title} onEdit={handleEditRoom} />
            <div className="room-card-actions">
                <Link to={`placedetector/${props.room.id}`}>
                    <img src={editImage} className="img-icon" />
                </Link>
                <button
                    className="delete-button"
                    id={'popver-btn-' + props.room.id}
                >
                    <img src={trashImage} className="img-icon" />
                </button>
            </div>
            <Popover
                placement="bottom"
                trigger="legacy"
                className="delete-popover-room"
                isOpen={isDeletePopoverVisible}
                target={'popver-btn-' + props.room.id}
                toggle={toggleDeletePopover}
            >
                <PopoverHeader>آیا از حذف اطمینان دارید؟</PopoverHeader>
                <PopoverBody className="delete-wrapper">
                    <Button color="danger" onClick={deleteHandler}>
                        بلی
                    </Button>
                    <Button onClick={toggleDeletePopover}>خیر</Button>
                </PopoverBody>
            </Popover>
        </Card>
    )
}

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = (dispatch) => {
    return {
        deleteRoom: (id) => dispatch(deleteRoom(id)),
        updateRoomTitle: (id, title) => dispatch(updateRoomTitle(id, title)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RoomItem)
